import { connect } from 'react-redux';

import { closeModal } from 'actions/modal';
import { MODAL_DELETE_FEEDITEM } from 'types/modal';
import  { actions } from '@amplement/backend-connector';
import Component from './index';

const mapStateToProps = state => ({
    ...state.modal[MODAL_DELETE_FEEDITEM]
});

const mapDispatchToProps = dispatch => ({
    onClose: () => dispatch(closeModal(MODAL_DELETE_FEEDITEM)),
    onSubmit: (_feed, _feedItem) => dispatch(actions.feedItems.requestDeleteFeedItem(_feed, _feedItem))
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
